import p1 from "../assets/gallery/p11.jpg";
import p2 from "../assets/gallery/p2.jpg";
import p3 from "../assets/gallery/p3.jpg";
import p4 from "../assets/gallery/p4.jpg";
import p5 from "../assets/gallery/p5.jpg";
import p6 from "../assets/gallery/p6.jpg";
import p7 from "../assets/gallery/p7.jpg";
import p8 from "../assets/gallery/p8.jpg";
import p9 from "../assets/gallery/p9.jpg";
import p10 from "../assets/gallery/p10.jpg";
import p11 from "../assets/gallery/p11.jpg";
import p12 from "../assets/gallery/p12.jpg";
import p13 from "../assets/gallery/p13.jpg";
import p14 from "../assets/gallery/p14.jpg";
import p15 from "../assets/gallery/p15.jpg";
import p16 from "../assets/gallery/p16.jpg";
import p17 from "../assets/gallery/p17.jpg";
import p18 from "../assets/gallery/p18.jpg";

export const galleryPhotos = [
  { src: p1, width: 1200, height: 800, alt: "TEAM KYNTRA" },
  { src: p2, width: 1200, height: 800, alt: "TRIP TO LYN VALLEY" },
  { src: p3, width: 1200, height: 800, alt: "SEA VIEW" },
  { src: p4, width: 1200, height: 800, alt: "PEDAL PATCH" },
  { src: p5, width: 1200, height: 800, alt: "TAKING BREIF OF PEDAL PATCH" },
  { src: p6, width: 1200, height: 800, alt: "BEST PROJECT - PEDAL PATCH" },

  { src: p7, width: 1200, height: 800, alt: "Gallery photo 7" },
  { src: p8, width: 1200, height: 800, alt: "Gallery photo 8" },
  { src: p9, width: 1200, height: 800, alt: "SPEAKING ON TECH" },
  { src: p10, width: 1200, height: 800, alt: "Gallery photo 10" },
  { src: p11, width: 1200, height: 800, alt: "TEAM KYNTRA" },
  { src: p12, width: 1200, height: 800, alt: "UX AND UI" },
  { src: p13, width: 1200, height: 800, alt: "CAPSTONE" },
  { src: p14, width: 1200, height: 800, alt: "DEEP DISCUSSION" },
  { src: p15, width: 1200, height: 800, alt: "TESTING DEV" },
  { src: p16, width: 1200, height: 800, alt: "BEST PROJECT" },
  { src: p17, width: 1200, height: 800, alt: "Gallery photo 17" },
  { src: p18, width: 1200, height: 800, alt: "Gallery photo 18" },
];
